// Declare interfaces only once
export interface SubClan {
  id: string;
  owner_id: string;
  owner_name: string;
  full_access: boolean;
  read: boolean;
  target_Person_id: string;

  // Fields from the root_families_view
  family_table_id: string;
  family_table_level: number;
  family_table_name: string;
  family_table_start_of_family_name: string;
  family_table_notes: string;
  family_table_country_id: string;
  family_table_city_id: string;
  family_table_gender: number;
  // Fields from the users table
  is_activated?: boolean;
  is_premium?: boolean;
  is_verified?: boolean;
  profile_completed?: boolean;
  position: number;
  level: number;
  name: string;
  start_of_family_name: string;
  notes: string;
  country_id: number;
  city_id: number;
  rootclan_name: string;
  gender: number;
}

  export interface TreeNode {
    name: string;
    id: string;
    level: number;
    children?: TreeNode[];
  }
  
  export const subClans: SubClan[] = [
    { 
      id: '1', 
      owner_id: 'owner123', 
      owner_name: 'John Doe', 
      full_access: false, 
      read: false, 
      target_Person_id: 'person123',
  
      // Fields from the root_families_view
      family_table_id: '1',
      family_table_level: 2, 
      family_table_name: 'Dragon Clan', 
      family_table_start_of_family_name: 'Dragon', 
      family_table_notes: 'Oldest clan in the region', 
      family_table_country_id: '101', 
      family_table_city_id: '201', 
      family_table_gender: 1, 
  
      // Fields from the users table
      is_activated: false, 
      is_premium: false, 
      is_verified: false, 
      profile_completed: false,
  
      // Extra fields
      position: 1, 
      level: 2, 
      name: 'Dragon Clan', 
      start_of_family_name: 'Dragon', 
      notes: 'Oldest clan in the region', 
      country_id: 101, 
      city_id: 201, 
      rootclan_name: 'Eastern Warriors', 
      gender: 1
    }
  ];
  

  export interface PermissionsModel {
    id: string;
    owner_id: string;
    target_account_id: string;
    target_Person_id: string;
    full_access: boolean;
    read: boolean;
  }
  
  // Initialize the tree data
  export const TREE_DATA: TreeNode[] = [];
  